import { ICliJob } from 'cliOld/types';
import { mapRecordFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';

export const getDetails = async (params, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/cli/job/details?${getQueryString(objectKeysCamelToSnakeCase(params))}`,
    signal
  );

  return mapRecordFromServer<ICliJob>(data.job);
};
